export class Appointment {
  id?: string;
  patient: {
    id: string;
    name: string;
  };

  doctor: {
    id: string;
    name: string;
  };

  startDate: Date;
  endDate: Date;
  specialty: {
    code: string;
    name: string;
    color: string;
  };

  constructor({
    id,
    patient,
    doctor,
    startDate,
    endDate,
    specialty
  }: {
    id?: string;
    patient: {
      id: string;
      name: string;
    };
    doctor: {
      id: string;
      name: string;
    };
    startDate: Date;
    endDate: Date;
    specialty: {
      code: string;
      name: string;
      color: string;
    };
  }) {
    this.id = id;
    this.patient = patient;
    this.doctor = doctor;
    this.startDate = startDate;
    this.endDate = endDate;
    this.specialty = specialty;
  }
}
